import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Tenant, TenantConfigurationUi } from '../../types/tenant.type';
import { ApiConversionHelper } from '../../helpers/api-conversion.helper';
import { TenantInfo } from '../../types/tenant-info';

@Injectable({ providedIn: 'root' })
export class TenantsApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/tenants`;
  }

  async getTenants(): Promise<Tenant[]> {
    const result = await this.get<Tenant[]>('');
    if (result == null) {
      return [];
    }
    // Convert the result to the Tenant type using ApiConversionHelper
    result.forEach(tenant => ApiConversionHelper.convertTenant(tenant));
    return result;
  }

  async getTenantsList(): Promise<TenantInfo[]> {
    return await this.get<TenantInfo[]>('list');
  }

  async getTenantsConfigurationUi(): Promise<TenantConfigurationUi[]> {
    return await this.get<TenantConfigurationUi[]>('configuration-ui');
  }

  async getTenantConfigurationUi(tenantId: string): Promise<TenantConfigurationUi> {
    return await this.get<TenantConfigurationUi>(`configuration-ui/${tenantId}`);
  }

  async getNewTenant(): Promise<Tenant> {
    const tenant = await this.get<Tenant>('new');
    ApiConversionHelper.convertTenant(tenant);
    return tenant;
  }

  async createTenant(tenant: Tenant): Promise<string> {
    ApiConversionHelper.convertTenantForApi(tenant);
    return await this.postWithResult<Tenant, string>('', tenant);
  }

  async updateTenant(tenant: Tenant): Promise<void> {
    ApiConversionHelper.convertTenantForApi(tenant);
    return await this.put('', tenant);
  }

  async deleteTenant(tenantId: string): Promise<void> {
    return await this.delete(`${tenantId}`);
  }

  async requestUpdatePendingAndRunningSessions(tenantId: string): Promise<void> {
    await this.post(`${tenantId}/request-update-sessions`, {});
  }

  async requestUpdatePendingAndRunningItems(tenantId: string): Promise<void> {
    await this.post(`${tenantId}/request-update-items`, {});
  }

  async refreshPowerAutomateCloudProcessUrls(tenantId: string, token: string): Promise<void> {
    return await this.post(`${tenantId}/refresh-power-automate-cloud-process-urls`, { token });
  }

  async testRpaConnection(tenantId: string): Promise<void> {
    return await this.post(`${tenantId}/test-rpa-connection`, null);
  }
}
